import { FigmaTypography, LoadingSpinner } from "@libs/zapi-ui/custom";
import { InitialHeader } from "./_InitialHeader";

export function GeneratingWidget({
  cancelSlot,
  progressMessage
}: {
  cancelSlot: React.ReactNode;
  progressMessage: string;
}) {
  return (
    <div className="h-full flex flex-col flex-grow overflow-y-auto" data-testid="claims-root">
      <InitialHeader />
      <div className="h-full flex flex-col p-1 bg-innoveraZinc-100 rounded-b-[8px]">
        <div className="h-full flex flex-col gap-2 items-center justify-center">
          <LoadingSpinner />

          <FigmaTypography variant="body-3" color="zinc500" className="text-center">
            {progressMessage || "Claims analysis queued..."}
          </FigmaTypography>
          {cancelSlot}
        </div>
      </div>
    </div>
  );
}
